import { createStaffAuthStore } from "@play/shared";

export type { AuthSession } from "@play/shared";

const store = createStaffAuthStore({
	storageKey: "play-admin.session",
	persistence: "local",
});

export const {
	subscribeAuth,
	getSession,
	getAccessToken,
	getRefreshToken,
	isPortalAdmin,
	hasStaffTag,
	setSession,
	patchSession,
	clearSession,
	isAuthenticated,
	loginWithStaffSession,
	applyStaffAccess,
	applyStaffAccount,
} = store;

export function canWorkRequests(): boolean {
	return isPortalAdmin() || hasStaffTag("DISCOUNT_REQUESTS");
}

export function defaultAuthenticatedPath(): string {
	return canWorkRequests() ? "/applications" : "/account";
}
